import {
  policyDecisionRequestPayloadType,
  policyDecisionRequestsPayloadType,
} from 'types/purchaseLicenseModalTypes';

export const LICENSE_QUERY_KEY = 'licensePricingData';
export const ACCOUNT_V2_SUMMARY_QUERY_KEY = 'accountV2Summary';

const getPolicyDecisionRequestPayload = (
  resourceName: string,
  scopeName: string,
  corpAccountNumber: string,
): policyDecisionRequestPayloadType => ({
  action: {
    name: 'READ',
  },
  resource: {
    name: resourceName,
    org: {
      id: 1,
    },
    scope: {
      name: scopeName,
    },
    type: 'ENTITY',
  },
  resourceOrg: {
    externalId: corpAccountNumber,
    type: 'CORP_ACCOUNT',
  },
});

export const getPolicyDecisionRequestPayloadForBMLFlow = (
  corpAccountNumber: string,
): policyDecisionRequestsPayloadType => [
  getPolicyDecisionRequestPayload(
    'USER_LICENSE',
    'LICENSING',
    corpAccountNumber,
  ),
  getPolicyDecisionRequestPayload(
    'TAX_ESTIMATION',
    'PRICING',
    corpAccountNumber,
  ),
  getPolicyDecisionRequestPayload(
    'LICENSE_ESTIMATION',
    'PRICING',
    corpAccountNumber,
  ),
  getPolicyDecisionRequestPayload(
    'ACCOUNT_METADATA',
    'ACCOUNT',
    corpAccountNumber,
  ),
];
